export enum HelpLinkFeatureFlagEnum {
    knowledgeHelpVideos = '^feature-flag-knowledge-help-videos$',
    publicationCatalog = '^feature-flag-publication-catalog$',
}
